module.exports = __webpack_public_path__ + "img/cbc.abf3d608.png";